import { render, staticRenderFns } from "./OngletCours.vue?vue&type=template&id=1338da5e"
import script from "./OngletCours.vue?vue&type=script&lang=js"
export * from "./OngletCours.vue?vue&type=script&lang=js"
import style0 from "./OngletCours.vue?vue&type=style&index=0&id=1338da5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports